import React, { useEffect } from "react"
import "./FeaturedModal.css"
import "./Bohl.css"
import "./VerantId.css"
import "./Firebreak.css"
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FeaturedSummaryData } from "../FeaturedSummaryData";
import BestBuy from "./BestBuy";
import HiRoad from "./HiRoad";
import CrbAuto from "./CrbAuto";
import Letsbloom from "./Letsbloom"
import OnlineGarage from "./OnlineGarage"
import Bohl from "./Bohl"
import VerantId from "./VerantId"
import Firebreak from "./Firebreak"
import UpArrow from "../../../images/up_arrow.svg"
import DownArrow from "../../../images/down_arrow.svg"
import Exit from "../../../images/exit.svg"
import GreenWave from "../../../images/HiRoad/green_wave.svg"
import GrayWave from "../../../images/CrbAuto/gray_wave.svg"
import LeftRedBars from "../../../images/CrbAuto/left_red_bars.svg"
import RightRedBars from "../../../images/CrbAuto/right_red_bars.svg"
import RoadWave from "../../../images/OnlineGarage/road_wave.png"
import LargeBohlImage from "../../../images/Bohl/large_bohl_image.png"
import VerantIdBorder from "../../../images/VerantId/verant_id_border.png"
import VerantLargeImages from "../../../images/VerantId/verant_large_images.png"
import DmvDatabaseCloud from "../../../images/VerantId/dmv_database_cloud.svg"
import AiComparisonCloud from "../../../images/VerantId/ai_comparison_cloud.svg"
import FirebreakFire from "../../../images/Firebreak/firebreak_fire.svg"

const FeaturedDetailsModal = (props) => {
    const handleClick = (direction) => {
        props.setActiveIndex((prevIndex) => {
            if (direction === "next") {
                if (prevIndex + 1 > FeaturedSummaryData.length - 1) {
                    return 0;
                }
                return prevIndex + 1;
            }
            if (prevIndex - 1 < 0) {                
                return FeaturedSummaryData.length - 1;
            }
            return prevIndex - 1;
        });
    };

    useEffect(() => {
        const setProjectKey = async () => {
            props.setActiveIndex(props.featuredProject.key)
        };

        (async function getProject() {
            if (props.featuredProject) {
                await setProjectKey();
            }
        })();
    }, [props.featuredProject]);

    return (
        <>
            <div 
                id="myNav" 
                style={{height: props.height}} 
                className={
                    `overlay overlay${props.activeIndex}`
                }
            >
                {props.activeIndex === 5 && props.height !== "0%" &&
                    <div className="bohlBackground">
                        <img
                            src={LargeBohlImage}
                            className="largeBohlImage"
                            alt="bohl restaurant app large display"
                        />
                    </div>
                }
                {props.activeIndex === 6 && props.height !== "0%" &&
                    <div className="verantIdBackground">
                        <img
                            src={VerantIdBorder}
                            className="verantIdBorder"
                            alt="verant id border divider"
                        />
                        <img
                            src={VerantLargeImages}
                            className="verantLargeImages"
                            alt="verant id verification interface"
                        />
                        <img
                            src={DmvDatabaseCloud}
                            className="dmvDatabaseCloud floatingCloud"
                            alt="dmv database cloud"
                        />
                        <img
                            src={AiComparisonCloud}
                            className="aiComparisonCloud floatingCloud"
                            alt="ai comparison cloud"
                        />
                    </div>
                }
                <Row style={{ position: "sticky", top: 0, zIndex: 15}}>
                    <Col>
                        <a onClick={() => handleClick('prev')} className="scrollUp">
                            <img src={UpArrow} style={{height: 30, marginTop:  15}} alt="up arrow"/>
                        </a>
                    </Col>
                    <Col className={props.activeIndex === 5 && props.height !== "0%" ? "bohlYellowCol" : ""}>
                        <a className="closebtn" onClick={() => {props.closeFeatureModal()}}>
                            <img src={Exit} style={{height: 20}} alt="exit icon" />
                        </a>
                    </Col>
                </Row>
                <Row style={{position: "sticky", bottom: 0, top: "89%", height: 0}}>
                    <Col lg="6">
                        <a onClick={() => handleClick('next')} className="scrollDown">
                            <img src={DownArrow} style={{height: 30}} alt="down arrow" />
                        </a>
                    </Col>
                    <Col
                        lg="6"
                        style={props.activeIndex === 5 && props.height !== "0%"
                            ? { backgroundColor: "#DEB57D", borderRadius: "0 0 0 80px" }
                            : {}
                        }
                    ></Col>
                </Row>
                {props.activeIndex === 2 &&
                    <img 
                        src={LeftRedBars}
                        className="redLeftBars"
                        alt="left red bars with animation"
                    />
                }
                {props.activeIndex === 0 &&
                    <div className="overlay-content">
                        <BestBuy />
                    </div>
                }   
                {props.activeIndex === 1 &&
                    <div className="overlay-content">
                        <HiRoad />
                    </div>
                }
                {props.activeIndex === 2 &&
                    <div className="overlay-content">
                        <CrbAuto />
                    </div>
                }
                {props.activeIndex === 3 &&
                    <div className="overlay-content">
                        <Letsbloom />
                    </div>
                }
                {props.activeIndex === 4 &&
                    <div className="overlay-content">
                        <OnlineGarage />
                    </div>
                }
                {props.activeIndex === 5 &&
                    <Bohl />
                }
                {props.activeIndex === 6 &&
                    <div className="overlay-content">
                        <VerantId />
                    </div>
                }
                {props.activeIndex === 7 && props.height !== "0%" &&
                    <div className="overlay-content">
                        <Firebreak />
                    </div>
                }

                {props.activeIndex === 1 &&
                    <img 
                        src={GreenWave} 
                        style={{ display: props.display}}
                        className="greenWave"
                        alt="hiroad green wave"
                    />
                }
                {props.activeIndex === 4 &&
                    <img 
                        src={RoadWave} 
                        style={{ display: props.display }}
                        className="roadWave"
                        alt="online garage aaa road wave"
                    />
                }
                {props.activeIndex === 2 &&
                    <>
                        <img 
                            src={GrayWave} 
                            style={{ display: props.display }}
                            className="grayWave"
                            alt="crb auto gray wave"
                        />
                        <img 
                            src={RightRedBars}
                            style={{ display: props.display }}
                            className="redBars"
                            alt="right red bars with animation"
                        />                        
                    </>
                }
                {props.activeIndex === 7 && props.height !== "0%" &&
                    <img
                        src={FirebreakFire}
                        style={{ display: props.display }}
                        className="firebreakFire"
                        alt="firebreak fire background"
                    />
                }
            </div>
        </>
    )
}

export default FeaturedDetailsModal;